module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privList"
  }, [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.loaded == false) ? _c('center', [_c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../shared/assets/images/3dloader.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.loaded == true) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [(_vm.search != '') ? _c('a', {
    staticClass: "searchTypeClear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearSearch.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons searchTypeClearText"
  }, [_vm._v("close")])]) : _vm._e(), _vm._v(" "), (_vm.search != '') ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.search == '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1)]) : _vm._e(), _vm._v(" "), (_vm.loaded == true) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.privList,
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.priv_key))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "40%"
          }
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.created))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.modified))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRIVS') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditPriv(props.item.id, props.item.priv_key)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRIVS') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeletePriv(props.item.id, props.item.priv_key)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])]) : _vm._e()]
      }
    }], null, false, 2303189229)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}